import React from 'react';

import { ProfilAutoriteFourriereViolationDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import { Input } from 'components/WrappedComponents';
import { useApi } from 'hooks/ApiStoreContext';
import { useUserStore } from 'hooks/UserStoreContext';
import { FormPlaceholders } from 'types/enums/FormPlaceholders';
import { CSSUtils } from 'utils/CSSUtils';

import { FicheProfilAutoriteFourriere, FieldProps } from '../types';
import { validateProfilAutoriteFourriereField } from '../utils';

function InputNumeroVoie({
  values,
  isEditable,
}: FieldProps): React.ReactElement {
  const user = useUserStore();
  const { AutoriteFourriereControllerApi } = useApi();

  const key: keyof FicheProfilAutoriteFourriere = 'numeroVoie';
  const label = 'Numéro de voie';

  return (
    <Input
      wrapperProps={{
        values: values,
        fieldKey: key,
        itemProps: {
          label: label,
          rules: [
            {
              validator: async (
                _rule,
                value: string | undefined,
              ): Promise<void> => {
                return await validateProfilAutoriteFourriereField(
                  AutoriteFourriereControllerApi,
                  ProfilAutoriteFourriereViolationDtoFormFieldEnum.NUMERO_VOIE,
                  user.idCorrelationAutoriteFourriere || '',
                  { ...values, [key]: value },
                );
              },
            },
          ],
          labelCol: { span: CSSUtils.defaultLabelCol },
          wrapperCol: { span: CSSUtils.largeWrapperCol },
        },
        editable: isEditable,
      }}
      inputProps={{
        placeholder: FormPlaceholders.Input,
        style: { width: '100%' },
      }}
    />
  );
}

export default InputNumeroVoie;
